import { z } from 'zod';
import { productSchema } from './products';

/**
 * Where a project is in its life. `draft` until its main order is placed; `ordered` from then, with a due date;
 * `cancelled` when that order is cancelled or refunded. `in_progress` and `delivered` belong to fulfilment.
 */
export const PROJECT_STATUSES = [
  'draft',
  'ordered',
  'in_progress',
  'delivered',
  'cancelled',
] as const;
export const projectStatusSchema = z.enum(PROJECT_STATUSES);
export type ProjectStatus = z.infer<typeof projectStatusSchema>;

const timestamp = z.iso.datetime({ offset: true });

/**
 * A row of public.projects as returned by supabase-js. Customers write none of it directly: `start_order` creates
 * it and the order functions move it on.
 */
export const projectSchema = z.object({
  id: z.uuid(),
  workspace_id: z.uuid(),
  name: z.string(),
  created_by: z.uuid().nullable(),
  sandbox_user_id: z.uuid().nullable(),
  created_at: timestamp,
  product: productSchema,
  status: projectStatusSchema,
  due_at: timestamp.nullable(),
  ordered_at: timestamp.nullable(),
  draft_touched_at: timestamp,
});
export type Project = z.infer<typeof projectSchema>;
